module.exports = __webpack_public_path__ + "static/media/employee.702713ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cta/employee.png
// module id = 26
// module chunks = 0